'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _View = require('./View');

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UserAutocomplete = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(UserAutocomplete, _PrismaCmsComponent);

  function UserAutocomplete() {
    _classCallCheck(this, UserAutocomplete);

    return _possibleConstructorReturn(this, (UserAutocomplete.__proto__ || Object.getPrototypeOf(UserAutocomplete)).apply(this, arguments));
  }

  _createClass(UserAutocomplete, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // const {
      //   query: {
      //     users,
      //   },
      // } = this.context;
      var users = 'query users(\n      $first: Int\n      $last: Int\n      $where: UserWhereInput\n      $orderBy: UserOrderByInput\n    ) {\n      objects: users(\n        where: $where\n        first: $first\n        last: $last\n        orderBy: $orderBy\n      ) {\n        id\n        fullname\n        username\n        image\n      }\n    }';
      var View = this.props.View;
      this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(users))(View);
      _get(UserAutocomplete.prototype.__proto__ || Object.getPrototypeOf(UserAutocomplete.prototype), 'componentWillMount', this) && _get(UserAutocomplete.prototype.__proto__ || Object.getPrototypeOf(UserAutocomplete.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var Renderer = this.Renderer;

      _objectDestructuringEmpty(this.context);

      var _props = this.props,
          where = _props.where,
          other = _objectWithoutProperties(_props, ['where']);

      var _getFilters = this.getFilters(),
          search = _getFilters.search,
          otherFilters = _objectWithoutProperties(_getFilters, ['search']);

      var filters = _extends({}, otherFilters);

      if (search) {
        Object.assign(filters, {
          OR: [{
            username_contains: search
          }, {
            fullname_contains: search
          }, {
            email_contains: search
          }]
        });
      }

      var content = null;
      content = _react2.default.createElement(Renderer, _extends({
        getFilters: function getFilters() {
          return _this2.getFilters();
        },
        setFilters: function setFilters(filters) {
          return _this2.setFilters(filters);
        },
        where: {
          AND: [_extends({}, where), _extends({}, filters)] // onChange={(event, value) => {
          //   this.setFilters({
          //     name_contains: value && value.trim() || undefined,
          //   })
          // }}

        }
      }, other));
      return content;
    }
  }]);

  return UserAutocomplete;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  View: _propTypes2.default.func.isRequired,
  first: _propTypes2.default.number,
  updateObject: _propTypes2.default.func.isRequired,
  Topic: _propTypes2.default.object.isRequired,
  inEditMode: _propTypes2.default.bool.isRequired,
  orderBy: _propTypes2.default.string
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  View: _View2.default,
  first: 20,
  orderBy: "fullname_ASC"
}), _temp);
exports.default = UserAutocomplete;
module.exports = exports['default'];